import { Handler,replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getBillTo, getBillTos } from "@insite/client-framework/Services/CustomersService";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { FindDefaultBillTo,chain } from "@insite/client-framework/Store/Pages/AccountSettings/Handlers/SetInitialValues";
import { BillToModel, ShipToModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = Handler<
    {},
    {
        defaultBillTo?: BillToModel;
        defaultShipTo?: ShipToModel;
        showSelectDefaultCustomer: boolean;
        useDefaultCustomer: boolean;
        hasMultipleBillTos: boolean;
    }
>;
export const CustomFindDefaultBillTo: HandlerType = async props => {
    const billTo = getBillToState(props.getState(),props.getState().context.session.billToId)
    let billTos:BillToModel[] = [];
    if(billTo.value){
        billTos = (await getBillTos({filter:billTo.value?.customerNumber})).billTos!
    }
    else{
        let billToData = await getBillTo({billToId: billTo.id!})
        billTos.push(billToData)
    }

    if (billTos.length === 1) {
        props.defaultBillTo = billTos[0];
    } else {
        const defaultBillTos = billTos.filter(o => o.isDefault);

        if (defaultBillTos.length === 1) {
            props.defaultBillTo = defaultBillTos[0];
        }
    }
};

replaceInChain(chain, FindDefaultBillTo, CustomFindDefaultBillTo);